import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const updateLink = createAsyncThunk('updateLink/updateLink', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: process.env.REACT_APP_API_URL + `link/${data.id}`,
            data: {
                long_url: data.long_url
            },
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }
        })
        return res
    } catch (error) {
        return error.response
    }
})

